import { render, staticRenderFns } from "./GroupAdd.vue?vue&type=template&id=d132c0ce&scoped=true"
import script from "./GroupAdd.vue?vue&type=script&lang=js"
export * from "./GroupAdd.vue?vue&type=script&lang=js"
import style0 from "./GroupAdd.vue?vue&type=style&index=0&id=d132c0ce&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d132c0ce",
  null
  
)

export default component.exports